export default __webpack_public_path__ + "static/media/animation.912ad31a.gif";